import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation";
import { Container, Row, Col, Form } from "react-bootstrap";
import ButtonLoader from "components/Common/ButtonLoader";
import { Link, useHistory } from "react-router-dom";
import {
  CreateCompanyData,
  GetCompanyData,
  GetCountryList,
  UpdateCompanyData,
} from "../../services/CompanyService";
import microsoftTeams from "../../assets/images/icon/microsoft-teams.png";
import linkedIn from "../../assets/images/icon/linkedin.png";
import zoomMeet from "../../assets/images/icon/zoom.png";
import googleMeet from "../../assets/images/icon/google-meet.png";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import ReactQuill from "react-quill";
import { getUserInfo } from "helpers/authHelper";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { checkPermissionStatus, getDeviceInfo } from "helpers/utils";
import { fetchBasicAdminDetails } from "helpers/common";
import { useTranslation } from "react-i18next";
import naukricom from "../../assets/images/icon/nakricom.svg";
import indeed from "../../assets/images/icon/indeed.svg";
import monster from "../../assets/images/icon/monster.svg";
import linkedins from "../../assets/images/icon/linkedin.svg";

const AllSetting = props => {
  const { t } = useTranslation();
  const history = useHistory();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  // const [statePayload, setStatePayload] = useState({});
  const [statePayload, setStatePayload] = useState({});
  const [countries, setCountries] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedAuto, setIsCheckedAuto] = useState(false);
  const [isCheckedEmail, setIsCheckedEmail] = useState(false);
  const [isCheckedNaukri, setIsCheckedNaukri] = useState(false);
  const [showTeamsDetails, setShowTeamsDetails] = useState(false);
  const [showZoomDetails, setShowZoomDetails] = useState(false);
  const [showLinkedInDetails, setShowLinkedInDetails] = useState(false);
  const [showGMeetDetails, setShowGMeetDetails] = useState(false);
  const [timezonelist, setTimezoneList] = useState([]);
  const [selectedTimezon, setSelectedTimezone] = useState("IST");
  const [isCheckedBehaviour, setIsCheckedBehaviour] = useState(false);
  const [isCheckedSocial, setIsCheckedSocial] = useState(false);
  const userInfo = getUserInfo();
  const [checkedPlatforms, setCheckedPlatforms] = useState({
    all: false,
    naukri: false,
    linkedin: false,
    indeed: false,
    monster: false,
  });

   const [selectedTheme, setSelectedTheme] = useState("bluetheme");
  let user_info = localStorage.getItem("user_info")
    ? JSON.parse(localStorage.getItem("user_info"))
    : "";

  const regionType = [
    { label: t(`Edit Details.Store`), value: "1", company_type: 1 },
    { label: t(`Edit Details.Area`), value: "0", company_type: 0 },
  ];

  const handleInput = event => {
    const { name, value } = event.target;

    setStatePayload(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };
  const checkStatus = value => {
    if (value === "2") {
      setIsChecked(false);
    } else if (value === "1") {
      setIsChecked(true);
    } else {
      setIsChecked(true);
    }
  };
  const checkStatusAuto = value => {
    if (value === "1") {
      setIsCheckedAuto(true);
    } else {
      setIsCheckedAuto(false);
    }
  };
  const checkEnableEmail = value => {
    if (value === "1") {
      setIsCheckedEmail(true);
    } else {
      setIsCheckedEmail(false);
    }
  };
  const checkEnableNaukri = value => {
    if (value === "1") {
      setIsCheckedNaukri(true);
    } else {
      setIsCheckedNaukri(false);
    }
  };

  const checkEnableBehaviour = value => {
    setIsCheckedBehaviour(value);
  };

  const checkEnableSocial = value => {
    setIsCheckedSocial(value);
  };

  const getTimeZones = () => {
    let storeTimezone = [];
    userInfo?.timeZones?.map(item => {
      if (item) {
        storeTimezone.push({
          value: item?.alias,
          label:
            item?.alias +
            " (" +
            item?.location +
            ")" +
            " (GMT " +
            item?.offset +
            ")",
          offset: item?.offset,
          id: item?.id,
        });
      }
    });
    setTimezoneList(storeTimezone);
  };

  const handleImageUpload = event => {
    const file = event.target.files[0];

    const allowedFileTypes = [
      "image/png",
      "image/jpg",
      "image/jpeg",
      "image/svg+xml",
    ];
    if (!allowedFileTypes?.includes(file?.type)) {
      setErrors(prevState => ({
        ...prevState,
        company_logo: t(
          `Edit Details.Only JPEG, PNG, SVG and GIF images are allowed`
        ),
      }));
      return;
    }

    setErrors(prevState => ({
      ...prevState,
      company_logo: "",
    }));

    // Setting the profile picture file;
    setStatePayload(prevState => ({
      ...prevState,
      company_logo: file,
    }));
  };

  const handleRoleSelection = roleId => {
    setStatePayload(prevState => ({
      ...prevState,
      role_id: roleId,
    }));
  };

  const validateNumber = txtMobId => {
    let indRegex = /^[1-9]{1}[0-9]{9}$/;
    let ausRegex =
      /^(\+?\(61\)|\(\+?61\)|\+?61|\(0[1-9]\)|0[1-9])?( ?-?[0-9]){7,9}$/;
    if (indRegex.test(txtMobId) == false && ausRegex.test(txtMobId) == false) {
      return t(`Edit Details.Valid Mobile Number is required`);
    }
    return "";
  };

  const isactivePlateform=activeValue=>{
     setCheckedPlatforms({
        all: activeValue,
        naukri: activeValue,
        linkedin: activeValue,
        indeed: activeValue,
        monster: activeValue,
      });
  }

  const handlePlatformChange = (platform) => {
    if (platform === "all") {
      const newValue = !checkedPlatforms.all;
      setCheckedPlatforms({
        all: newValue,
        naukri: newValue,
        linkedin: newValue,
        indeed: newValue,
        monster: newValue,
      });
    } else {
      const updated = { ...checkedPlatforms, [platform]: !checkedPlatforms[platform] };
      updated.all =
        updated.naukri &&
        updated.linkedin &&
        updated.indeed &&
        updated.monster;
      setCheckedPlatforms(updated);
    }
  };

  const validateEmail = value => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) {
      return t(`Edit Details.Email is required`);
    }
    if (emailRegex.test(value) == false) {
      return t(`Edit Details.Valid Email is required`);
    }
    return "";
  };

  const handleSubmit = async event => {
    event.preventDefault();
    // if (!checkPermissionStatus("/settings", "edit")) {
    //   toast.error("Edit Permissions Required!");
    //   return false;
    // }
    setErrors({});
    setIsLoading(true);
    let errorObj = {};

    // Catching and setting errors;
    if (!statePayload?.company_name?.trim()) {
      errorObj["company_name"] = t(`Edit Details.Please Enter Company Name!`);
    }
    if (!statePayload?.email?.trim()) {
      errorObj["email"] = validateEmail(statePayload?.email);
    }
    if (!statePayload?.mobile_number) {
      errorObj["mobile_number"] = validateNumber(statePayload?.mobile_number);
    }
    if (!statePayload?.company_description?.trim()) {
      errorObj["company_description"] = t(
        `Edit Details.Please Enter Company Description`
      );
    }
    if (
      !statePayload?.username?.trim() ||
      statePayload?.username?.includes(".")
    ) {
      errorObj["username"] = t(
        `Edit Details.Please Enter Valid Company Username`
      );
    }
    if (!statePayload?.company_logo) {
      errorObj["company_logo"] = t(`Edit Details.Company Logo is Required`);
    }

    if (!statePayload?.company_address) {
      errorObj["company_address"] = t(
        `Edit Details.Company Address is Required`
      );
    }
    if (!statePayload?.country_id) {
      errorObj["country_id"] = t(`Edit Details.Country is Required`);
    }
    if (!statePayload?.company_type) {
      errorObj["company_type"] = t(`Edit Details.Hierarchy Type is Required`);
    }

    if (!statePayload?.auto_reject) {
      errorObj["auto_reject"] = t(`Edit Details.This Field is Required`);
    }

    if (showTeamsDetails) {
      if (!statePayload?.clientId) {
        errorObj["clientId"] = t(`Edit Details.This Field is Required`);
      }
      if (!statePayload?.authority) {
        errorObj["authority"] = t(`Edit Details.This Field is Required`);
      }
      if (!statePayload?.clientSecret) {
        errorObj["clientSecret"] = t(`Edit Details.This Field is Required`);
      }
      if (!statePayload?.teams_user_id) {
        errorObj["teams_user_id"] = t(`Edit Details.This Field is Required`);
      }
    }
    if (showGMeetDetails) {
      if (!statePayload?.client_id_g_meet) {
        errorObj["client_id_g_meet"] = t(`Edit Details.This Field is Required`);
      }
      if (!statePayload?.tenant_id_g_meet) {
        errorObj["tenant_id_g_meet"] = t(`Edit Details.This Field is Required`);
      }
      if (!statePayload?.client_secrets_g_meet) {
        errorObj["client_secrets_g_meet"] = t(
          `Edit Details.This Field is Required`
        );
      }
      if (!statePayload?.callback_url_g_meet) {
        errorObj["callback_url_g_meet"] = t(
          `Edit Details.This Field is Required`
        );
      }
    }

    if (showLinkedInDetails) {
      if (!statePayload?.client_id_linkedin) {
        errorObj["client_id_linkedin"] = t(
          `Edit Details.This Field is Required`
        );
      }
      if (!statePayload?.organization_id_linkedin) {
        errorObj["organization_id_linkedin"] = t(
          `Edit Details.This Field is Required`
        );
      }
      if (!statePayload?.client_secrets_linkedin) {
        errorObj["client_secrets_linkedin"] = t(
          `Edit Details.This Field is Required`
        );
      }
      if (!statePayload?.scope_linkedin) {
        errorObj["scope_linkedin"] = t(`Edit Details.This Field is Required`);
      }
    }

    if (showZoomDetails) {
      if (!statePayload?.client_id_zoom) {
        errorObj["client_id_zoom"] = "This Field is Required.";
      }
      if (!statePayload?.zoom_code) {
        errorObj["zoom_code"] = "This Field is Required.";
      }
      if (!statePayload?.client_secrets_zoom) {
        errorObj["client_secrets_zoom"] = "This Field is Required.";
      }
      if (!statePayload?.zoom_redirect_uri) {
        errorObj["zoom_redirect_uri"] = "This Field is Required.";
      }
      if (!statePayload?.scope_zoom) {
        errorObj["scope_zoom"] = "This Field is Required.";
      }
      if (!statePayload?.theme) {
        errorObj["theme"] = "Theme is Required";
      }
    }

    if (isCheckedEmail) {
      if (!statePayload?.nylas_api_key) {
        errorObj["nylas_api_key"] = t(`Edit Details.This Field is Required`);
      }
      if (!statePayload?.nylas_grant_id) {
        errorObj["nylas_grant_id"] = t(`Edit Details.This Field is Required`);
      }
      if (!statePayload?.nylas_api_uri) {
        errorObj["nylas_api_uri"] = t(`Edit Details.This Field is Required`);
      }
    }
    if (isCheckedNaukri) {
      if (!statePayload?.naukri_api_key) {
        errorObj["naukri_api_key"] = t(`Edit Details.This Field is Required`);
      }
      if (!statePayload?.naukri_secret_key) {
        errorObj["naukri_secret_key"] = t(
          `Edit Details.This Field is Required`
        );
      }
      if (!statePayload?.naukri_api_uri) {
        errorObj["naukri_api_uri"] = t(`Edit Details.This Field is Required`);
      }
    }
    const selectedPlatforms = Object.keys(checkedPlatforms).filter(
      platform => platform !== "all" && checkedPlatforms[platform]
    );
    // Setting the error object if any errors are present;
    if (Object.keys(errorObj)?.length > 0) {
      setErrors(prevState => ({
        ...prevState,
        ...errorObj,
      }));
      toast.error(t(`Edit Details.Please fill proper details!`));
      setIsLoading(false);
      return;
    }
    const time_zone_id = timezonelist?.find(
      el => el?.value === selectedTimezon
    )?.id;

    // setting payload to save inside the database;
    let payload = new FormData();
    payload.append("company_name", statePayload?.company_name);
    payload.append("mobile_number", statePayload?.mobile_number);
    payload.append("company_description", statePayload?.company_description);
    payload.append("company_logo", statePayload?.company_logo);
    payload.append("company_address", statePayload?.company_address);
    payload.append("company_theme", statePayload?.theme);
    payload.append("email", statePayload?.email);
    payload.append("username", statePayload?.username);
    payload.append("front_page_content", statePayload?.front_page_content);
    payload.append("country_id", statePayload?.country_id);
    payload.append("company_type", statePayload?.company_type);
    payload.append("aws_bucket_name", statePayload?.aws_bucket_name);
    payload.append("cooling_off_period", statePayload?.cooling_off_period);
    payload.append("aws_s3_key", statePayload?.aws_s3_key);
    payload.append("aws_s3_secret_key", statePayload?.aws_s3_secret_key);
    payload.append("aws_region", statePayload?.aws_region);
    payload.append("time_zone_id", time_zone_id);
    payload.append("teams_meeting", showTeamsDetails ? "1" : "0");
    payload.append("linkedin", showLinkedInDetails ? "1" : "0");
    payload.append("work_permit", statePayload?.work_permit);
    payload.append("auto_reject", statePayload?.auto_reject);
    payload.append("email_enable", statePayload?.email_enable);
    payload.append("naukri_enable", statePayload?.naukri_enable);
    payload.append(
      "is_behaviour_score_enabled",
      statePayload?.behaviour_enable
    );
    payload.append(
      "is_social_enabled",
      statePayload?.social_enable
    );
    
    payload.append("status", 1);
    payload.append("platforms", JSON.stringify(selectedPlatforms) || "[]");
    if (showTeamsDetails) {
      payload.append("clientId", statePayload?.clientId);
      payload.append("authority", statePayload?.authority);
      payload.append("clientSecret", statePayload?.clientSecret);
      payload.append("teams_user_id", statePayload?.teams_user_id);
    }
    payload.append("gmeet_meeting", showGMeetDetails ? "1" : "0");
    if (showGMeetDetails) {
      payload.append("client_id_g_meet", statePayload?.client_id_g_meet);
      payload.append("tenant_id_g_meet", statePayload?.tenant_id_g_meet);
      payload.append(
        "client_secrets_g_meet",
        statePayload?.client_secrets_g_meet
      );
      payload.append("callback_url_g_meet", statePayload?.callback_url_g_meet);
    }

    if (showLinkedInDetails) {
      payload.append("client_id_linkedin", statePayload?.client_id_linkedin);
      payload.append(
        "organization_id_linkedin",
        statePayload?.organization_id_linkedin
      );
      payload.append(
        "client_secrets_linkedin",
        statePayload?.client_secrets_linkedin
      );
      payload.append("scope_linkedin", statePayload?.scope_linkedin);
    }
    payload.append("zoom_meeting", showZoomDetails ? "1" : "0");
    if (showZoomDetails) {
      payload.append("client_id_zoom", statePayload?.client_id_zoom);
      payload.append("zoom_code", statePayload?.zoom_code);
      payload.append("client_secrets_zoom", statePayload?.client_secrets_zoom);
      payload.append("zoom_redirect_uri", statePayload?.zoom_redirect_uri);
      payload.append("scope_zoom", statePayload?.scope_zoom);
    }

    if (isCheckedEmail) {
      payload.append("nylas_api_key", statePayload?.nylas_api_key);
      payload.append("nylas_grant_id", statePayload?.nylas_grant_id);
      payload.append("nylas_api_uri", statePayload?.nylas_api_uri);
    }
    if (isCheckedNaukri) {
      payload.append("naukri_api_key", statePayload?.naukri_api_key);
      payload.append("naukri_secret_key", statePayload?.naukri_secret_key);
      payload.append("naukri_api_uri", statePayload?.naukri_api_uri);
    }
    console.log('selectedPlatforms',(selectedPlatforms))
    console.log('check pauload',payload)

    let device_info = (await getDeviceInfo(navigator)) || {};
    payload.append("device_info", JSON.stringify(device_info || "{}"));

    await UpdateCompanyData(payload)
      .then(res => {
        if (res.status === 200) {
          //  console.log("response true", res.status);return false;
          toast.success(res?.data?.msg);
          // Save theme to localStorage
          localStorage.setItem("company_theme", statePayload?.theme);
          // Apply the theme class to the body
          localStorage.setItem("linkedin_status", statePayload?.linkedin);
          localStorage.setItem(
            "isBehaviourScoreEnabled",
            statePayload?.behaviour_enable
          );
localStorage.setItem(
            "isSocialEnabled",
            statePayload?.social_enable
          );

          fetchBasicAdminDetails();

          // setIsLoading(false);
          setTimeout(() => {
            setIsLoading(false);
            window.location.reload();
          }, 2000);
        } else {
          // console.log("response else", res.status);
          //return false;
          toast.error(res?.data?.message);
          // toast.error(res?.data?.message);
          setIsLoading(false);
        }
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  };

  //checkbox-hideshow
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  const handleTeamsCheckboxChange = () => {
    if (showTeamsDetails == false) {
      setShowZoomDetails(false);
      setShowLinkedInDetails(false);
    }
    setShowTeamsDetails(!showTeamsDetails);
  };
  const handleLinkedInCheckboxChange = value => {
    value === "1"
      ? setShowLinkedInDetails(true)
      : setShowLinkedInDetails(false);
    if (value === "1") {
      setShowTeamsDetails(false);
      setShowZoomDetails(false);
    }
  };

  const handleZoomInCheckboxChange = value => {
    value === "1" ? setShowZoomDetails(true) : setShowZoomDetails(false);
    if (value === "1") {
      setShowTeamsDetails(false);
      setShowLinkedInDetails(false);
    }
  };

  const handleGMeetCheckboxChange = () => {
    setShowGMeetDetails(!showGMeetDetails);
  };

  useEffect(() => {
    getTimeZones();
    GetCompanyData()
      .then(res => {
        let companyData = res?.data?.data || {};
        companyData.company_type = regionType?.find(
          el => el.company_type === companyData.company_type
        )?.value;
        setStatePayload({ ...companyData });
        setShowTeamsDetails(companyData?.teams_meeting === 1 ? true : false);
        if (
          (companyData && companyData?.work_permit === 1) ||
          companyData?.work_permit === 0
        ) {
          //console.log('Enter',companyData?.work_permit);
          setIsChecked(true);
        }
        if (companyData && companyData?.linkedin === 1) {
          setShowLinkedInDetails(true);
        }
        if (companyData && companyData?.zoom_meeting === 1) {
          setShowZoomDetails(true);
        }
        if (companyData && companyData?.work_permit === 1) {
          setIsCheckedAuto(true);
        }
        if (companyData && companyData?.email_enable === 1) {
          setIsCheckedEmail(true);
        }
        if (companyData && companyData?.naukri_enable === 1) {
          setIsCheckedNaukri(true);
        }
        let isactiveBehaviour = false;
        if (companyData && companyData?.is_behaviour_score_enabled) {
          isactiveBehaviour = true;
        }

          let isactiveSocial = false;
        if (companyData && companyData?.is_social_enabled) {
          isactiveSocial = true;
        }

        const platforms = companyData?.platforms || [];
        const basePlatforms = ["naukri", "linkedin", "indeed", "monster"];

        const updatedCheckedPlatforms = {
          all: basePlatforms.every(p => platforms.includes(p)), // true if ALL are present
        };

        basePlatforms.forEach(platform => {
          updatedCheckedPlatforms[platform] = platforms.includes(platform);
        });

        setCheckedPlatforms(updatedCheckedPlatforms);

        setIsCheckedBehaviour(isactiveBehaviour);
        handleInput({
          target: { name: "behaviour_enable", value: isactiveBehaviour },
        });
         setIsCheckedSocial(isactiveSocial);
        handleInput({
          target: { name: "social_enable", value: isactiveSocial },
        });

        
      })
      .catch(err => {});

    GetCountryList()
      .then(res => {
        setCountries(res?.data?.data || []);
      })
      .catch(err => {});
  }, []);

  if (checkPermissionStatus("settings", "view")) {
    return (
      <div className="page-content">
        <h5 className="text-center p-5">{t(`Edit Details.Access Denied`)}</h5>
      </div>
    );
  }

 

  const handleThemeChange = theme => {
    setSelectedTheme(theme); // Update the selected theme
    setStatePayload(prevState => ({
      ...prevState,
      theme: theme, // Add the theme to the payload
    }));
    //console.log("Selected Theme:", theme);
  };
  return (
    <div className="pending-list-page feedbacks ">
      <ToastContainer />
      {/* <Row className="mb-3 align-items-center border-bottom py-2">
          <Col sm="6">
            <h5 className="text-uppercase heading-one">Edit Company Details</h5>
          </Col>
        </Row> */}

      <div className="joblist-container create-vacancy">
        <Row className="mb-1 align-items-center">
          <Col lg="6" md="6">
            <Link to="/dashboard">
              <h5 className="text-uppercase heading-one">
                <img src={arrow_btn} alt="arrow_btn" />
                {t(`Edit Details.Edit Company Details`)}
              </h5>
            </Link>
          </Col>

          {/* <Col lg="6" md="6">
              <div class="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
                <Link to="/vacancyType-list" className="btn btn-primary">
                  Back To Listing
                </Link>
              </div>
            </Col> */}
        </Row>
      </div>

      {/* <h2 className="sub-heading-text mb-3 heading-four">Company Details:</h2> */}

      <div className="outerTab-box-wrapper below-vacancy pt-3">
        <div className="form-details-section">
          <div className="compnay-details">
            <Row>
              <Form.Group className="col-xl-4 col-lg-6 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Company Name`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="company_name"
                  value={statePayload?.company_name}
                  onChange={handleInput}
                  title={`${t(`Edit Details.Company Name`)}`}
                />
                {errors?.company_name && (
                  <small className="text-danger">
                    {" "}
                    {errors?.company_name}{" "}
                  </small>
                )}
              </Form.Group>

              <Form.Group className="col-xl-4 col-lg-6 col-md-6  mb-3 floating-label">
                <Form.Label className="float-label">
                  {" "}
                  {t(`Edit Details.Email`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="email"
                  value={statePayload?.email}
                  disabled
                  onChange={handleInput}
                  title={`${t(`Edit Details.Email`)}`}
                />
                {errors?.email && (
                  <small className="text-danger"> {errors?.email} </small>
                )}
              </Form.Group>

              <Form.Group className="col-xl-4 col-lg-6 col-md-6  mb-3 floating-label">
                <Form.Label className="float-label">
                  {" "}
                  {t(`Edit Details.Mobile No`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="mobile_number"
                  value={statePayload?.mobile_number}
                  onChange={handleInput}
                  title={`${t(`Edit Details.Mobile No`)}`}
                />
                {errors?.mobile_number && (
                  <small className="text-danger">
                    {" "}
                    {errors?.mobile_number}{" "}
                  </small>
                )}
              </Form.Group>

              <Form.Group className="col-xl-4 col-lg-6 col-md-6  mb-3">
                <Form.Label className="float-label">
                  {" "}
                  {t(`Edit Details.Company Logo`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <AvForm>
                  <AvField
                    type="file"
                    className="form-control"
                    id="company_logo"
                    name="company_logo"
                    // errorMessage="Company Logo is required"
                    placeholder=" "
                    accept=".jpeg, .png, .jpg, .gif, .svg"
                    validate={{ required: { value: true } }}
                    // value={statePayload?.company_logo}
                    onChange={handleImageUpload}
                    title={`${t(`Edit Details.Company Logo`)}`}
                  />
                </AvForm>
                {statePayload?.company_logo && (
                  <div className="mt-2 d-flex">
                    {typeof statePayload?.company_logo === "string" && (
                      <img
                        id="stringPic"
                        style={{ maxWidth: "80%" }}
                        src={statePayload?.company_logo}
                        alt="company logo"
                      />
                    )}
                    {typeof statePayload?.company_logo === "object" && (
                      <img
                        id="objectPic"
                        style={{ maxWidth: "80%" }}
                        src={URL.createObjectURL(statePayload?.company_logo)}
                      />
                    )}
                  </div>
                )}
                {errors?.company_logo && (
                  <small className="text-danger">
                    {" "}
                    {errors?.company_logo}{" "}
                  </small>
                )}
              </Form.Group>

              <Form.Group className="col-xl-4 col-lg-6 col-md-6  mb-3">
                <Form.Label className="float-label">
                  {t(`Edit Details.Company Username`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`Edit Details.Enter Company Username`)}
                  name="username"
                  value={statePayload?.username}
                  onChange={handleInput}
                  title={`${t(`Edit Details.Company Username`)}`}
                />
                {errors?.username && (
                  <small className="text-danger"> {errors?.username} </small>
                )}
              </Form.Group>

              <Form.Group className="col-xl-4 col-lg-6 col-md-6  mb-3">
                <Form.Label className="float-label">
                  Company Theme
                  <span class="text-danger">*</span>
                  <div className="radio-buttons themecolorp7">
                    <label className="custom-radio" htmlFor="bluetheme">
                      <span className="d-none"> Blue Theme</span>
                      <input
                        type="radio"
                        name="theme"
                        value="bluetheme"
                        id="bluetheme"
                        checked={selectedTheme === "bluetheme"}
                        onChange={() => handleThemeChange("bluetheme")}
                        title={`Please select bluetheme`}
                      />
                      <span className="radio-btn bluetheme"></span>
                    </label>
                    <label className="custom-radio" htmlFor="redtheme">
                      <span className="d-none"> Red Theme</span>
                      <input
                        type="radio"
                        name="theme"
                        value="redtheme"
                        id="redtheme"
                        checked={selectedTheme === "redtheme"}
                        onChange={() => handleThemeChange("redtheme")}
                        title={`Please select redtheme`}
                      />
                      <span className="radio-btn redtheme"></span>
                    </label>
                    <label className="custom-radio" htmlFor="greentheme">
                      <span className="d-none"> Green Theme</span>
                      <input
                        type="radio"
                        name="theme"
                        value="greentheme"
                        id="greentheme"
                        checked={selectedTheme === "greentheme"}
                        onChange={() => handleThemeChange("greentheme")}
                        title={`Please select greentheme`}
                      />
                      <span className="radio-btn greentheme"></span>
                    </label>
                    <label className="custom-radio" htmlFor="yellowtheme">
                      <span className="d-none"> Yellow Theme</span>
                      <input
                        type="radio"
                        name="theme"
                        value="yellowtheme"
                        id="yellowtheme"
                        checked={selectedTheme === "yellowtheme"}
                        onChange={() => handleThemeChange("yellowtheme")}
                        title={`Please select yellowtheme`}
                      />
                      <span className="radio-btn yellowtheme"></span>
                    </label>
                  </div>
                </Form.Label>
              </Form.Group>
            </Row>

            <Row>
              <Form.Group className="col-xl-4 col-lg-6 col-md-6 mb-3 floating-label position-relative mt-2 required-skill-card">
                <Form.Label className="float-label">
                  {t(`Edit Details.Company Description`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                {/* <Form.Control
                type="text"
                placeholder=" "
                name="company_description"
                value={statePayload?.company_description}
                onChange={handleInput}
              /> */}
                <div title={`${t(`Edit Details.Company Description`)}`}>
                  <ReactQuill
                    style={{ height: "150px" }}
                    placeholder={t(`Edit Details.Company Description`)}
                    name="company_description"
                    value={statePayload?.company_description}
                    onChange={content => {
                      setStatePayload(prevState => ({
                        ...prevState,
                        ["company_description"]: content,
                      }));
                    }}
                    title={`Please enter ${t(
                      `Edit Details.Company Description`
                    ).toLowerCase()}`}
                  />
                </div>
                {errors?.company_description && (
                  <small className="text-danger">
                    {" "}
                    {errors?.company_description}{" "}
                  </small>
                )}
              </Form.Group>

              <Form.Group className="col-xl-4 col-lg-6 col-md-6 mb-3 floating-label position-relative mt-2 required-skill-card">
                <Form.Label className="float-label">
                  {t(`Edit Details.Company Address`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                {/* <Form.Control
                type="text"
                placeholder=" "
                name="company_address"
                value={statePayload?.company_address}
                onChange={handleInput}
              /> */}
                <div title={`${t(`Edit Details.Company Address`)}`}>
                  <ReactQuill
                    style={{ height: "150px" }}
                    placeholder={t(`Edit Details.Company Address`)}
                    name="company_address"
                    value={statePayload?.company_address}
                    onChange={content => {
                      setStatePayload(prevState => ({
                        ...prevState,
                        ["company_address"]: content,
                      }));
                    }}
                  />
                </div>
                {errors?.company_address && (
                  <small className="text-danger">
                    {" "}
                    {errors?.company_address}{" "}
                  </small>
                )}
              </Form.Group>

              <Form.Group className="col-xl-4 col-lg-6 col-md-6 mb-3 floating-label position-relative mt-2 required-skill-card">
                <Form.Label className="float-label">
                  {t(`Edit Details.Front Page Content`)}
                </Form.Label>
                {/* <ReactQuill
                type="text"
                placeholder=" "
                name="front_page_content"
                value={statePayload?.front_page_content}
                onChange={handleInput}
              /> */}
                <div title={`${t(`Edit Details.Front Page Content`)}`}>
                  <ReactQuill
                    style={{ height: "150px" }}
                    placeholder={t(`Edit Details.Front Page Content`)}
                    name="front_page_content"
                    value={
                      statePayload?.front_page_content !== "null"
                        ? statePayload?.front_page_content
                        : ""
                    }
                    onChange={content => {
                      setStatePayload(prevState => ({
                        ...prevState,
                        ["front_page_content"]: content,
                      }));
                    }}
                  />
                </div>
                {errors?.front_page_content && (
                  <small className="text-danger">
                    {" "}
                    {errors?.front_page_content}{" "}
                  </small>
                )}
              </Form.Group>

              <div className="breaker-row"></div>

              <Form.Group className="col-xl-4 col-lg-6 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Select Country`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                {/* {console.log(countries)} */}
                <div
                  title={
                    statePayload.country_id
                      ? `${
                          countries.find(
                            elem => elem.value == statePayload.country_id
                          )?.label
                        }`
                      : `${t(`EmployeeReferral.Status`)}`
                  }
                >
                  <Select
                    className="mb-2"
                    placeholder={t(`Edit Details.Select Country`)}
                    id="preferred_location"
                    name="preferred_location"
                    options={countries || []}
                    value={countries?.find(
                      el => el.value === statePayload?.country_id
                    )}
                    onChange={e => {
                      setStatePayload(prevState => ({
                        ...prevState,
                        ["country_id"]: e.value,
                      }));
                    }}
                    aria-label={t(`Edit Details.Select Country`)} // Adds an ARIA label
                    tabIndex="0" // Explicitly specifies focusable tabindex
                  />
                </div>
                {errors?.country_id && (
                  <small className="text-danger"> {errors?.country_id} </small>
                )}
              </Form.Group>
              <Form.Group className="col-xl-4 col-lg-6 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Choose Hierarchy`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <div
                  title={
                    statePayload.company_type
                      ? `${
                          regionType.find(
                            elem => elem.value == statePayload.company_type
                          )?.label
                        }`
                      : `${t(`Edit Details.Choose Hierarchy`)}`
                  }
                >
                  <Select
                    className="mb-2"
                    placeholder="Select Hierarchy Type"
                    id="company_type"
                    name="company_type"
                    options={regionType}
                    value={regionType?.find(
                      el => el.value === statePayload?.company_type
                    )}
                    onChange={e => {
                      setStatePayload(prevState => ({
                        ...prevState,
                        ["company_type"]: e.value,
                      }));
                    }}
                    aria-label={t(`Edit Details.Choose Hierarchy`)} // Adds an ARIA label
                    tabIndex="0" // Explicitly specifies focusable tabindex
                  />
                </div>
                {errors?.company_type && (
                  <small className="text-danger">
                    {" "}
                    {errors?.company_type}{" "}
                  </small>
                )}
              </Form.Group>

              <Form.Group className="col-xl-4 col-lg-6 col-md-6 mb-3 floating-label">
                <Form.Label> {t(`Edit Details.Time Zone`)}:</Form.Label>
                <div
                  title={
                    statePayload.select_timezon
                      ? `${
                          timezonelist.find(
                            elem => elem.value == statePayload.select_timezon
                          )?.label
                        }`
                      : `${t(`Edit Details.Time Zone`)}`
                  }
                >
                  <Select
                    placeholder={"Select Timezone"}
                    id="select_timezon"
                    options={timezonelist?.sort((a, b) => {
                      if (a?.alias?.toLowerCase() < b?.alias?.toLowerCase()) {
                        return -1;
                      }
                      if (a?.alias?.toLowerCase() > b?.alias?.toLowerCase()) {
                        return 1;
                      }
                      return 0;
                    })}
                    onChange={e => setSelectedTimezone(e.value)}
                    value={timezonelist.filter(
                      item => item?.value === selectedTimezon
                    )}
                    errorMessage="Required Field"
                    aria-label={t(`Edit Details.Time Zone`)} // Adds an ARIA label
                    tabIndex="0" // Explicitly specifies focusable tabindex
                  />
                </div>
              </Form.Group>

              <Form.Group className="col-md-4 mb-3 floating-label">
                <Form.Label className="d-flex justify-content-between flex-wrap">
                  {t(`Edit Details.Cooling Off Period (in Days)`)}:{" "}
                  <small>{t(`Edit Details.Set this to 0 to disable it`)}</small>
                </Form.Label>
                <div>
                  <Form.Control
                    type="number"
                    placeholder="Enter Period"
                    name="cooling_off_period"
                    value={statePayload?.cooling_off_period}
                    onChange={handleInput}
                    title={`${t(`Edit Details.Cooling Off Period (in Days)`)}`}
                  />
                </div>
              </Form.Group>

              <Form.Group className="col-xl-4 col-lg-6 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.AWS Bucket Name`)}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="aws_bucket_name"
                  value={
                    statePayload?.aws_bucket_name !== "null"
                      ? statePayload?.aws_bucket_name
                      : ""
                  }
                  title={`${t(`Edit Details.AWS Bucket Name`)}`}
                  onChange={handleInput}
                />
                {errors?.aws_bucket_name && (
                  <small className="text-danger">
                    {" "}
                    {errors?.aws_bucket_name}{" "}
                  </small>
                )}
              </Form.Group>

              <Form.Group className="col-xl-4 col-lg-6 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.AWS S3 Key`)}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="aws_s3_key"
                  title={`${t(`Edit Details.AWS S3 Key`)}`}
                  value={
                    statePayload?.aws_s3_key !== "null"
                      ? statePayload?.aws_s3_key
                      : ""
                  }
                  onChange={handleInput}
                />
                {errors?.aws_s3_key && (
                  <small className="text-danger"> {errors?.aws_s3_key} </small>
                )}
              </Form.Group>

              <Form.Group className="col-xl-4 col-lg-6 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.AWS S3 Secret Key`)}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="aws_s3_secret_key"
                  title={`${t(`Edit Details.AWS S3 Secret Key`)}`}
                  value={
                    statePayload?.aws_s3_secret_key !== "null"
                      ? statePayload?.aws_s3_secret_key
                      : ""
                  }
                  onChange={handleInput}
                />
                {errors?.aws_s3_secret_key && (
                  <small className="text-danger">
                    {" "}
                    {errors?.aws_s3_secret_key}{" "}
                  </small>
                )}
              </Form.Group>

              <Form.Group className="col-xl-4 col-lg-6 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.AWS Region`)}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="aws_region"
                  value={
                    statePayload?.aws_region !== "null"
                      ? statePayload?.aws_region
                      : ""
                  }
                  onChange={handleInput}
                  title={`${t(`Edit Details.AWS Region`)}`}
                />
                {errors?.aws_region && (
                  <small className="text-danger"> {errors?.aws_region} </small>
                )}
              </Form.Group>
              <Form.Group className="col-xl-4 col-lg-6 col-md-6 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Work Permit of Above Country`)}
                </Form.Label>
                <div className="mt-2 d-flex gap-1">
                  <label className="switch" htmlFor={"tableSwitch"}>
                    <span className="d-none">
                      {t(`Edit Details.Work Permit of Above Country`)}
                    </span>
                    <input
                      type="checkbox"
                      id={`tableSwitch`}
                      onClick={e => {
                        let value = e.target.checked ? "1" : "2";
                        checkStatus(value);
                        handleInput({
                          target: { name: "work_permit", value: value },
                        });
                      }}
                      title={`${t(
                        `Edit Details.Work Permit of Above Country`
                      )}`}
                      checked={isChecked}
                    />
                    <div className="slider round"></div>
                  </label>
                  <span>
                    {isChecked
                      ? t(`Edit Details.Active`)
                      : t(`Edit Details.Deactive`)}
                  </span>
                </div>
                {errors?.work_permit && (
                  <p className="text-danger"> {errors?.work_permit} </p>
                )}
              </Form.Group>
            </Row>
          </div>

          <div className="compnay-details row mt-4 mb-4">
            <Col lg={6} className="marign-sets">
              <label className="teams-name">
                {t(`Edit Details.Microsoft Teams`)}
              </label>
              <div className="online-meeting">
                <div className="online-meeting-img">
                  <span>
                    <img src={microsoftTeams} alt="" />
                  </span>
                </div>
                <div className="online-meeting-content w-100">
                  <p>{t(`Edit Details.Microsoft Teams text`)}</p>
                  <div className="job-status-toggle justify-content-start">
                    <label className="switch">
                      <span className="d-none">
                        {t(`Edit Details.Microsoft Teams text`)}
                      </span>
                      <input
                        type="checkbox"
                        checked={showTeamsDetails}
                        onChange={handleTeamsCheckboxChange}
                      />
                      <span className="slider round"></span>
                    </label>
                    <span>
                      {showTeamsDetails
                        ? t(`Edit Details.Active`)
                        : t(`Edit Details.Deactive`)}
                    </span>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={6} className="marign-sets">
              <label>{t(`Edit Details.Google Meet`)}</label>
              <div className="online-meeting" style={{ opacity: 0.6 }}>
                <div className="online-meeting-img">
                  <span>
                    <img src={googleMeet} alt="" />
                  </span>
                </div>
                <div className="online-meeting-content w-100">
                  <p>{t(`Edit Details.Coming Soon`)}</p>
                  {/* <div className="job-status-toggle justify-content-start">
                  <label className="switch">
                    <input type="checkbox" onChange={handleGMeetCheckboxChange} />
                    <span className="slider round"></span>
                  </label>
                  <span>{showGMeetDetails ? 'Active' : 'Deactive'}</span>
                </div> */}
                </div>
              </div>
            </Col>

            <Col lg={6} className="marign-sets">
              <label>{t(`Edit Details.LinkedIn`)}</label>
              <div className="online-meeting">
                <div className="online-meeting-img">
                  <span>
                    <img src={linkedIn} alt="" />
                  </span>
                </div>
                <div className="online-meeting-content w-100">
                  <p>{t(`Edit Details.LinkedIn text`)}</p>
                  <div className="job-status-toggle justify-content-start">
                    <label className="switch">
                      <span className="d-none">
                        {t(`Edit Details.LinkedIn text`)}
                      </span>
                      <input
                        type="checkbox"
                        onClick={e => {
                          let value = e.target.checked ? "1" : "0";
                          //checkStatus(value);
                          handleLinkedInCheckboxChange(value);
                          handleInput({
                            target: { name: "linkedin", value: value },
                          });
                        }}
                        defaultChecked={showLinkedInDetails}
                        checked={showLinkedInDetails}
                      />
                      <span className="slider round"></span>
                    </label>
                    <span>
                      {showLinkedInDetails
                        ? t(`Edit Details.Active`)
                        : t(`Edit Details.Deactive`)}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={6} className="marign-sets">
              <label>{t(`Edit Details.Zoom Meeting`)}</label>
              <div className="online-meeting">
                <div className="online-meeting-img">
                  <span>
                    <img src={zoomMeet} alt="" />
                  </span>
                </div>
                <div className="online-meeting-content w-100">
                  {/* <h4>{t(`Edit Details.Zoom Meeting`)}</h4> */}
                  <p>{t(`Edit Details.Zoom text`)}</p>
                  <div className="job-status-toggle justify-content-start">
                    <label className="switch">
                      <span className="d-none">
                        {t(`Edit Details.Zoom text`)}
                      </span>
                      <input
                        type="checkbox"
                        onClick={e => {
                          let value = e.target.checked ? "1" : "0";
                          handleZoomInCheckboxChange(value);
                          handleInput({
                            target: { name: "zoom", value: value },
                          });
                        }}
                        defaultChecked={showZoomDetails}
                        checked={showZoomDetails}
                      />
                      <span className="slider round"></span>
                    </label>
                    <span>
                      {showZoomDetails
                        ? t(`Edit Details.Active`)
                        : t(`Edit Details.Deactive`)}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
          </div>

          {showTeamsDetails && (
            <div className="compnay-details teams row">
              <Form.Group className="col-md-6 col-lg-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Client ID`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="clientId"
                  value={statePayload?.clientId}
                  onChange={handleInput}
                  title={`${t(`Edit Details.Client ID`)}`}
                />
                {errors?.clientId && (
                  <small className="text-danger"> {errors?.clientId} </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Authority URL`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="authority"
                  value={statePayload?.authority}
                  onChange={handleInput}
                  title={`${t(`Edit Details.Authority URL`)}`}
                />
                {errors?.authority && (
                  <small className="text-danger"> {errors?.authority} </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Client Secret`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="clientSecret"
                  value={statePayload?.clientSecret}
                  onChange={handleInput}
                  title={`${t(`Edit Details.Client Secret`)}`}
                />
                {errors?.clientSecret && (
                  <small className="text-danger">
                    {" "}
                    {errors?.clientSecret}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Teams Email ID`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="teams_user_id"
                  value={statePayload?.teams_user_id}
                  onChange={handleInput}
                  title={`${t(`Edit Details.Teams Email ID`)}`}
                />
                {errors?.teams_user_id && (
                  <small className="text-danger">
                    {" "}
                    {errors?.teams_user_id}{" "}
                  </small>
                )}
              </Form.Group>
            </div>
          )}

          {showZoomDetails && (
            <div className="compnay-details teams row">
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.ZOOM Client ID`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="client_id_zoom"
                  value={statePayload?.client_id_zoom}
                  onChange={handleInput}
                  title={`${t(`Edit Details.ZOOM Client ID`)}`}
                />
                {errors?.client_id_zoom && (
                  <small className="text-danger">
                    {" "}
                    {errors?.client_id_zoom}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.ZOOM Auth Code`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="zoom_code"
                  value={statePayload?.zoom_code}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.ZOOM Auth Code`
                  ).toLowerCase()}`}
                />
                {errors?.zoom_code && (
                  <small className="text-danger"> {errors?.zoom_code} </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.ZOOM Client Secret`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="client_secrets_zoom"
                  value={statePayload?.client_secrets_zoom}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.ZOOM Client Secret`
                  ).toLowerCase()}`}
                />
                {errors?.client_secrets_zoom && (
                  <small className="text-danger">
                    {" "}
                    {errors?.client_secrets_zoom}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.ZOOM Redirect URI`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="zoom_redirect_uri"
                  value={statePayload?.zoom_redirect_uri}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.ZOOM Redirect URI`
                  ).toLowerCase()}`}
                />
                {errors?.zoom_redirect_uri && (
                  <small className="text-danger">
                    {" "}
                    {errors?.zoom_redirect_uri}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Scope`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="scope_zoom"
                  value={statePayload?.scope_zoom}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Scope`
                  ).toLowerCase()}`}
                />
                {errors?.scope_zoom && (
                  <small className="text-danger"> {errors?.scope_zoom} </small>
                )}
              </Form.Group>
            </div>
          )}
          {showGMeetDetails && (
            <div className="compnay-details  g-meet row">
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Client ID G-Meet`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="client_id_g_meet"
                  value={statePayload?.client_id_g_meet}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Client ID G-Meet`
                  ).toLowerCase()}`}
                />
                {errors?.client_id_g_meet && (
                  <small className="text-danger">
                    {" "}
                    {errors?.client_id_g_meet}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Tenant ID G-Meet`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="tenant_id_g_meet"
                  value={statePayload?.tenant_id_g_meet}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Tenant ID G-Meet`
                  ).toLowerCase()}`}
                />
                {errors?.tenant_id_g_meet && (
                  <small className="text-danger">
                    {" "}
                    {errors?.tenant_id_g_meet}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Client Secret G-Meet`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="client_secrets_g_meet"
                  value={statePayload?.client_secrets_g_meet}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Client Secret G-Meet`
                  ).toLowerCase()}`}
                />
                {errors?.client_secrets_g_meet && (
                  <small className="text-danger">
                    {" "}
                    {errors?.client_secrets_g_meet}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Callback Url G-Meet`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="callback_url_g_meet"
                  value={statePayload?.callback_url_g_meet}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Callback Url G-Meet`
                  ).toLowerCase()}`}
                />
                {errors?.callback_url_g_meet && (
                  <small className="text-danger">
                    {" "}
                    {errors?.callback_url_g_meet}{" "}
                  </small>
                )}
              </Form.Group>
            </div>
          )}

          {showLinkedInDetails && (
            <div className="compnay-details teams row">
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Client ID`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="client_id_linkedin"
                  value={statePayload?.client_id_linkedin}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Client ID`
                  ).toLowerCase()}`}
                />
                {errors?.client_id_linkedin && (
                  <small className="text-danger">
                    {" "}
                    {errors?.client_id_linkedin}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Organisation ID`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="organization_id_linkedin"
                  value={statePayload?.organization_id_linkedin}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Organisation ID`
                  ).toLowerCase()}`}
                />
                {errors?.organization_id_linkedin && (
                  <small className="text-danger">
                    {" "}
                    {errors?.organization_id_linkedin}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Client Secret`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="client_secrets_linkedin"
                  value={statePayload?.client_secrets_linkedin}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Client Secret`
                  ).toLowerCase()}`}
                />
                {errors?.client_secrets_linkedin && (
                  <small className="text-danger">
                    {" "}
                    {errors?.client_secrets_linkedin}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Scope`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="scope_linkedin"
                  value={statePayload?.scope_linkedin}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Scope`
                  ).toLowerCase()}`}
                />
                {errors?.scope_linkedin && (
                  <small className="text-danger">
                    {" "}
                    {errors?.scope_linkedin}{" "}
                  </small>
                )}
              </Form.Group>
            </div>
          )}

          <Form.Group className="col-md-6 mb-4 floating-label ">
            <Form.Label className="float-label">
              {t(`Edit Details.Auto Rejection Feature`)}
              <span class="text-danger">*</span>
            </Form.Label>
            <div className="mt-2 d-flex gap-2">
              <label className="switch" htmlFor={"tableLicenseSwitch"}>
                <span className="d-none">
                  {t(`Edit Details.Auto Rejection Feature`)}
                </span>
                <input
                  type="checkbox"
                  id={`tableLicenseSwitch`}
                  onClick={e => {
                    let value = e.target.checked ? "1" : "0";
                    checkStatusAuto(value);
                    handleInput({
                      target: { name: "auto_reject", value: value },
                    });
                  }}
                  // defaultChecked={statePayload?.auto_reject === "1"}
                  checked={isCheckedAuto}
                />
                <div className="slider round"></div>
              </label>
              <span>
                {isCheckedAuto
                  ? t(`Edit Details.Active`)
                  : t(`Edit Details.Deactive`)}
              </span>
            </div>

            {/* <Form.Check
                type="checkbox"
                name="status"
                className="font-size-20 mx-2"
                checked={statePayload?.status === "1"}
                onChange={(e) => {
                  let value = e.target.checked ? "1" : "0"
                  handleInput({ target: { name: 'status', value: value } })
                }}
              /> */}

            {errors?.auto_reject && (
              <p className="text-danger"> {errors?.auto_reject} </p>
            )}
          </Form.Group>

          <Form.Group className="col-md-6 mb-4 floating-label ">
            <Form.Label className="float-label">
              {t(`Edit Details.Enable Email Render Features`)}
              <span class="text-danger">*</span>
            </Form.Label>
            <div className="mt-2 d-flex gap-2">
              <label className="switch" htmlFor={"tableLicenseSwitchEnable"}>
                <span className="d-none">
                  {t(`Edit Details.Enable Email Render Features`)}
                </span>
                <input
                  type="checkbox"
                  id={`tableLicenseSwitchEnable`}
                  onClick={e => {
                    let value = e.target.checked ? "1" : "0";
                    checkEnableEmail(value);
                    handleInput({
                      target: { name: "email_enable", value: value },
                    });
                  }}
                  // defaultChecked={statePayload?.auto_reject === "1"}
                  checked={isCheckedEmail}
                />
                <div className="slider round"></div>
              </label>
              <span>
                {isCheckedEmail
                  ? t(`Edit Details.Active`)
                  : t(`Edit Details.Deactive`)}
              </span>
            </div>

            {errors?.email_enable && (
              <p className="text-danger"> {errors?.email_enable} </p>
            )}
          </Form.Group>

          {isCheckedEmail && (
            <div className="compnay-details teams row">
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Nylas API Key`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="nylas_api_key"
                  value={statePayload?.nylas_api_key}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Nylas API Key`
                  ).toLowerCase()}`}
                />
                {errors?.nylas_api_key && (
                  <small className="text-danger">
                    {" "}
                    {errors?.nylas_api_key}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Nylas Grant ID`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="nylas_grant_id"
                  value={statePayload?.nylas_grant_id}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Nylas Grant ID`
                  ).toLowerCase()}`}
                />
                {errors?.nylas_grant_id && (
                  <small className="text-danger">
                    {" "}
                    {errors?.nylas_grant_id}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Nylas API Uri`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="nylas_api_uri"
                  value={statePayload?.nylas_api_uri}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Nylas API Uri`
                  ).toLowerCase()}`}
                />
                {errors?.nylas_api_uri && (
                  <small className="text-danger">
                    {" "}
                    {errors?.nylas_api_uri}{" "}
                  </small>
                )}
              </Form.Group>
            </div>
          )}

          <Form.Group className="col-md-6 mb-4 floating-label ">
            <Form.Label className="float-label">
              {t(`Edit Details.Enable Naukri`)}
              <span class="text-danger">*</span>
            </Form.Label>
            <div className="mt-2 d-flex gap-2">
              <label className="switch" htmlFor={"tableLicenseSwitchEnables"}>
                <span className="d-none">
                  {t(`Edit Details.Enable Naukri`)}
                </span>
                <input
                  type="checkbox"
                  id={`tableLicenseSwitchEnables`}
                  onClick={e => {
                    let value = e.target.checked ? "1" : "0";
                    checkEnableNaukri(value);
                    handleInput({
                      target: { name: "naukri_enable", value: value },
                    });
                  }}
                  // defaultChecked={statePayload?.auto_reject === "1"}
                  checked={isCheckedNaukri}
                />
                <div className="slider round"></div>
              </label>
              <span>
                {isCheckedNaukri
                  ? t(`Edit Details.Active`)
                  : t(`Edit Details.Deactive`)}
              </span>
            </div>

            {errors?.naukri_enable && (
              <p className="text-danger"> {errors?.naukri_enable} </p>
            )}
          </Form.Group>

          {isCheckedNaukri && (
            <div className="compnay-details teams row">
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Naukri API Key`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="naukri_api_key"
                  value={statePayload?.naukri_api_key}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Naukri API Key`
                  ).toLowerCase()}`}
                />
                {errors?.naukri_api_key && (
                  <small className="text-danger">
                    {" "}
                    {errors?.naukri_api_key}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Naukri secret key`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="naukri_secret_key"
                  value={statePayload?.naukri_secret_key}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Naukri Secret Key`
                  ).toLowerCase()}`}
                />
                {errors?.naukri_secret_key && (
                  <small className="text-danger">
                    {" "}
                    {errors?.naukri_secret_key}{" "}
                  </small>
                )}
              </Form.Group>
              <Form.Group className="col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`Edit Details.Naukri API Uri`)}
                  <span class="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" "
                  name="naukri_api_uri"
                  value={statePayload?.naukri_api_uri}
                  onChange={handleInput}
                  title={`Please enter ${t(
                    `Edit Details.Naukri API Uri`
                  ).toLowerCase()}`}
                />
                {errors?.naukri_api_uri && (
                  <small className="text-danger">
                    {" "}
                    {errors?.naukri_api_uri}{" "}
                  </small>
                )}
              </Form.Group>
            </div>
          )}

          <Form.Group className="col-md-6 mb-4 floating-label ">
            <Form.Label className="float-label">
              {t(`Edit Details.Enable_behavscore`)}
              <span class="text-danger">*</span>
            </Form.Label>
            <div className="mt-2 d-flex gap-2">
              <label className="switch" htmlFor={"active_behaviour"}>
                <span className="d-none">
                  {t(`Edit Details.Enable_behavscore`)}
                </span>
                <input
                  type="checkbox"
                  id={`active_behaviour`}
                  onClick={e => {
                    let value = e.target.checked ? true : false;
                    checkEnableBehaviour(value);
                    handleInput({
                      target: { name: "behaviour_enable", value: value },
                    });
                  }}
                  // defaultChecked={statePayload?.auto_reject === "1"}
                  checked={isCheckedBehaviour}
                />
                <div className="slider round"></div>
              </label>
              <span>
                {isCheckedBehaviour
                  ? t(`Edit Details.Active`)
                  : t(`Edit Details.Deactive`)}
              </span>
            </div>

            {errors?.behaviour_enable && (
              <p className="text-danger"> {errors?.behaviour_enable} </p>
            )}
          </Form.Group>

          <Form.Group className="col-md-6 mb-4 floating-label ">
            <Form.Label className="float-label">
              Enable Social platforms
              <span className="text-danger">*</span>
            </Form.Label>
            <div className="mt-2 d-flex gap-2">
              <label className="switch" htmlFor="active_social">
                <span className="d-none">
                  {t(`Edit Details.Enable_behavscore`)}
                </span>
                <input
                  type="checkbox"
                  id="active_social"
                  onClick={e => {
                    const value = e.target.checked;
                    checkEnableSocial(value);
                    isactivePlateform(value);
                    handleInput({
                      target: { name: "social_enable", value },
                    });
                  }}
                  checked={isCheckedSocial}
                />
                <div className="slider round"></div>
              </label>
              <span>
                {isCheckedSocial
                  ? t(`Edit Details.Active`)
                  : t(`Edit Details.Deactive`)}
              </span>
            </div>

            {errors?.social_enable && (
              <p className="text-danger">{errors?.social_enable}</p>
            )}
          </Form.Group>

          {/* Conditionally render the social platforms */}
          {isCheckedSocial && (
        <Col lg={12}>
  <Form.Group className="mb-4 mt-3 position-relative">
    <Form.Label>Select platforms to publish this job:</Form.Label>
    <div className="job-across-list">
      
      {/* Check All */}
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id="checkAll"
          checked={checkedPlatforms.all}
          onChange={() => handlePlatformChange("all")}
        />
        <label className="form-check-label" htmlFor="checkAll">
          All
        </label>
      </div>

      {/* Naukri */}
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id="checkNaukri"
          checked={checkedPlatforms.naukri}
          onChange={() => handlePlatformChange("naukri")}
        />
        <label className="form-check-label" htmlFor="checkNaukri">
          <img src={naukricom} alt="naukri" />
        </label>
      </div>

      {/* LinkedIn */}
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id="checkLinkedin"
          checked={checkedPlatforms.linkedin}
          onChange={() => handlePlatformChange("linkedin")}
        />
        <label className="form-check-label" htmlFor="checkLinkedin">
          <img src={linkedins} alt="linkedins" />
        </label>
      </div>

      {/* Indeed */}
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id="checkIndeed"
          checked={checkedPlatforms.indeed}
          onChange={() => handlePlatformChange("indeed")}
        />
        <label className="form-check-label" htmlFor="checkIndeed">
          <img src={indeed} alt="indeed" />
        </label>
      </div>

      {/* Monster */}
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id="checkMonster"
          checked={checkedPlatforms.monster}
          onChange={() => handlePlatformChange("monster")}
        />
        <label className="form-check-label" htmlFor="checkMonster">
          <img src={monster} alt="monster" />
        </label>
      </div>

    </div>
  </Form.Group>
</Col>

          )}

          <Form.Group className="cta text-center d-flex justify-content-start mt-4 gap-3 mb-0 pt-3">
            <ButtonLoader
              title={t(`Edit Details.Cancel`)}
              variant="secondary"
              className="btn btn-primary reset"
              type="submit"
              onClick={() => {
                history.push("/dashboard");
              }}
              // loading={isLoading}
              // message={"Saving"}
            />
            <ButtonLoader
              title={t(`Edit Details.Save Details`)}
              variant="primary"
              className="btn btn-primary search"
              style={{ marginLeft: "5px" }}
              type="submit"
              loading={isLoading}
              message={"Saving"}
              onClick={async e => {
                await handleSubmit(e);
                //  window.location.reload();
              }}
            />
          </Form.Group>
        </div>
      </div>
    </div>
  );
};

export default AllSetting;
